<script lang="ts">
  import { onMount } from 'svelte';
  import { setReloadOnNavigate } from '../routes/[...slug]/+page.svelte';
  import type { EditorStoryblokWithAtlas } from '$lib/server/expanders/editorPage';
  import { ATLAS_RESPONSE_ELEMENT_ID } from '$lib/scope-atlas-css-constants';

  const { blok, skipCss }: { blok: EditorStoryblokWithAtlas; skipCss?: boolean } = $props();

  let assetsLoaded = $state(false);
  onMount(async () => {
    await appendAtlasVariables(`${blok.atlas.head}`);
    await loadScripts(blok.atlas.stickerappJS, 'stickerapp-js-' + ATLAS_RESPONSE_ELEMENT_ID);
    await loadScripts(blok.atlas.editorJS, 'editor-js-' + ATLAS_RESPONSE_ELEMENT_ID);
    assetsLoaded = true;
  });

  function appendAtlasVariables(html: string) {
    return new Promise((resolve, reject) => {
      try {
        eval(html);
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  $effect(() => {
    if (blok.useNewCheckout) {
      return;
    }
    setReloadOnNavigate();
  });

  function loadScripts(url: string, id: string) {
    return new Promise((resolve, reject) => {
      if (document.getElementById(id)) {
        resolve(true); // Script already exists, dont need to load again
        return;
      }

      const script = document.createElement('script');
      script.src = url;
      script.id = id;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => reject(new Error(`Failed to load script ${url}`));

      document.head.appendChild(script);
    });
  }
</script>

<div id={ATLAS_RESPONSE_ELEMENT_ID}>
  {#if !skipCss}
    <link rel="stylesheet" href={blok.atlas.stickerappCSS} type="text/css" media="all" />
  {/if}
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html blok.atlas.editorModal}
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html blok.atlas.globalModals}
  {#if blok.atlas.data && assetsLoaded}
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html blok.atlas.data}
  {/if}
</div>

<style>
  /*
   Prevents the header from overlapping the editor when navigating directly to `/editor/edit/1`
   */
  :global(.editor) {
    z-index: 20;
    display: block;
  }
</style>
